import { Result } from "../models/interfaces";
import { BaseService } from "./BaseService";

export type RegisterBusiness = {
  name?: string;
  email?: string;
  address?: string;
  domainCode?: string;
  phone?: string;
  userName?: string;
  password?: string;
  confirmPassword?: string;
  userEmail?: string;
  userPhone?: string;
};

export interface IBusinessService {
  registerBusiness: (request: RegisterBusiness) => Promise<Result<any>>;
}

export class BusinessService extends BaseService implements IBusinessService {
  async registerBusiness(request: RegisterBusiness) {
    var res = await this.post<any>(
      this.getBaseUrl() + "/api/business/register",
      request
    );

    console.log(res);

    return new Promise<Result<any>>((resolve, reject) => {
      resolve({
        message: "Business registered successfully",
        data: res,
        status: true,
        code: 200,
      });
      reject();
    });
  }
}

const _businessService = new BusinessService();
export default _businessService;
